<template>
    <!-- 段落标题 -->
    <div @click="setEditIndex(index)">
        <el-row :gutter="10" class="question-box">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
                <TitleEditor 
                    :isTest="true"
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
            </el-col>
            <el-col class="edit-btn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <div v-if="question.logicalSettings != undefined" class="edit-btn" @click="() => $emit('jumpshow', question)">
                    <el-badge 
                        v-if="question.logicalSettings.num" 
                        :value="question.logicalSettings.num" >
                        <i class="el-icon-share"  ></i>
                    </el-badge>
                </div>
                <i class="el-icon-delete edit-btn" 
                    v-if="question.isedit"
                    @click="questiondel(question.qid)"></i>
            </el-col>
        </el-row>

    </div>
</template>
<script>
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
        components: {
            TitleEditor,
        },
        data() {
            return {

            }
        },
        props: {
            question: {},
            index: {type:Number,default:0}
        },
        watch: {
            'question.questionsName':{
                handler(newV, oldV){
                    if (newV !== oldV && this.question.bqid) {
                        this.question.bqid = ''
                    }
                },
                deep: true
            },
        },
        methods: {
			copyClick(question){
				this.$emit('questionCopy',question)
			},
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            questiondel(id){
                this.$emit("questiondel",id);
            }
        },
        created() {
            if (!this.question.quesCode) {
                this.$set(this.question, 'quesCode', '')
            }
        },
    }
</script>

<style scoped lang="scss">
    .inputvalue{
        border: 1px solid rgb(154, 145, 145);
        width: 770px;
        height: 35px;
    }
    .edit-btn-box{    
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .edit-btn{
            font-size: 22px;
            line-height: 40px;
            text-align: right;
            cursor: pointer;
        }
        .edit-btn+.edit-btn{
            margin-left: 30px;
        }
    }
.item .el-badge__content.is-fixed{top:10px;}

    .el_item_option {
        line-height: 40px;
        height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }


    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-bottom: 14px;
    }
</style>
